import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { AlertTriangle, RotateCw } from 'lucide-react';
import { isChunkError, reloadForNewVersion } from '../lib/chunks';

/** Friendly screen for anything a page throws while rendering. */
export function RouteError() {
  const err = useRouteError();
  const stale = isChunkError(err);
  if (stale) reloadForNewVersion();
  const notFound = isRouteErrorResponse(err) && err.status === 404;
  const message = isRouteErrorResponse(err) ? `${err.status} ${err.statusText}` : (err as Error)?.message ?? String(err);
  return (
    <div className="route-error">
      <div className="route-error__card">
        <AlertTriangle size={28} />
        <h1>{stale ? 'Lumnos was just updated' : notFound ? 'Page not found' : 'Something went wrong on this page'}</h1>
        <p>{stale ? 'Reload to get the latest version.' : 'Reloading usually fixes it. Your chats and work are saved.'}</p>
        <div className="route-error__actions">
          <button className="btn btn--primary btn--md" onClick={() => window.location.reload()}><RotateCw size={15} /><span>Reload</span></button>
          <a className="btn btn--secondary btn--md" href="/">Go home</a>
        </div>
        {!stale && !notFound && <details><summary>Details</summary><code>{message}</code></details>}
      </div>
    </div>
  );
}
